<template>
  <section  :class="[userAgent=='PHONE'?'preloadWrap':'preloadWrap2']">
    <!-- {{currentProgress}} -->

<!--    <div class="preloadTips" v-if="currentProgress!=100">资源加载中...</div>-->
    <div class="preloadLogo">
    </div>
    <div class="" :class="[userAgent=='PHONE'?'xiaozun':'xiaozun2']">
      <div class="dianji" v-show="currentProgress==100"></div>
    </div>
    <div  :class="[userAgent=='PHONE'?'pretitle':'pretitle2']" v-if="showgoto" @click="goto"></div>
    <div class="logo"></div>
    <div class="" :class="[userAgent=='PHONE'?'progressBox':'progressBox2']" v-if="!showgoto">
      <div class="progressBar" :style="{width:currentProgress+'%'}"></div>
      <div class="progressBar-num">{{currentProgress}}%</div>
    </div>
  </section>
</template>

<script>
import {listFile} from "@/config/preloadFile";

export default {
  name: "preload.vue",
  data() {
    return {
      isShow: false,
      currentProgress:0,

      showgoto:false,
      userAgent:'',

    };
  },
  created() {
    this.handleGetInto();
    this.userAgent=this.obtainCurrPlatform();
  },
  methods:{
    handleGetInto() {
      let list = listFile;
      // console.log(listFile,'listFile');
      let _this = this
      let preload = new createjs.LoadQueue(true);
      preload.on("progress", _this.handleFileProgress);
      preload.on("complete", _this.loadComplete);
      preload.setMaxConnections(20);
      preload.loadManifest(list);
    },
    handleFileProgress(e) {
      let progress = (e.progress * 100 | 0);
      // console.log(progress,e.progress * 100 | 0);
      this.currentProgress = progress;
    },
    loadComplete(event) {
      // console.log(event, "已加载完毕全部资源");
      this.currentProgress = 100;
      this.showgoto=true;
      // this.$emit('preloadComplete',false)
    },
    obtainCurrPlatform:()=>{
      // 判断当前使用的平台 PC PHONE
      let ios = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
      let android = /(Android)/i.test(navigator.userAgent);
      // console.log(ios,android)
      if(ios||android){
        const deviceWidth = document.documentElement.clientWidth || document.body.clientWidth;
        // deviceWidth = 750px(设计图w)
        // document.querySelector('html').style.fontSize = deviceWidth / 100 / 7.5 + 'px';
        document.documentElement.style.fontSize = deviceWidth / 100 / 7.5 + 'px';
        return 'PHONE'
      }else{
        return 'PC'
      }
    },
    goto(){
      this.$emit('preloadComplete',false);
      $('html,body').animate({scrollTop:0},300);
    }

  }
}
</script>

<style scoped>
.preloadWrap {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 500;
  background-color: #fdd7c1;
  /* background-image: linear-gradient(180deg, #C3EDF8 , #B1E3F1, #97D071); */
  padding-top: 250px;
  box-sizing: border-box;
}
.preloadWrap2{
  background-color: #fdd7c1;
  /*height: 100vh;*/
  box-sizing: border-box;
  padding-top: 250px;
}

.progressBar{
  height: 40px;
  width: 0;
  border-radius: 20px;
  background-color: #e95d61;
  /*background-color: #FFFFFF;*/
  /* background-color: #79A1E2; */

}
.progressBar-num{
  width: 546px;
  height: 40px;
  font-size: 26px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 40px;
  text-align: center;
  position: absolute;
  top: 5px;
}
.preloadTips{
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  color: #FFFFFF;
  /* color: #3A3A3A; */
  line-height: 48px;
  margin-top: 20px;

}






.preloadLogo{
  width: 100%;
  position: absolute;
  left: 0;
  z-index: 500;
  bottom: calc(50px + var(--safe-area-bottom-constant));
  bottom: calc(50px + var(--safe-area-bottom-env));
  text-align: center;
}
.preloadLogo img{
  width: 150px;
  /*height:46px;*/
}

.progressBox{
  width: 546px;
  height: calc(52px + 2px);
  border-radius: 25px;
  border: 1px solid #e95d61;
  /* border: 1px solid #79A1E2; */

  padding: 6px;
  box-sizing: border-box;
  position: absolute;
  left: calc(50% - 273px);
  bottom: 32vh;
}
.progressBox2{
  width: 546px;
  height: calc(52px + 2px);
  border-radius: 25px;
  border: 1px solid #e95d61;
  padding: 6px;
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;
  margin-top: 180px;
}
.pretitle2{
  width: 340px;
  height: 107px;
  background: url("../../public/guangming_milk/png/djkq2.png") no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 150px;
  animation: move 2s infinite;

}

.pretitle{
  width: 340px;
  height: 107px;
  background: url("../../public/guangming_milk/png/djkq2.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: calc(50% - 170px);
  bottom: 32vh;
  animation: move 2s infinite;
}


@keyframes move {
  0% {
    transform: scale(1);
  }

25% {
  transform: scale(1.05);
}
50% {
  transform: scale(1);
}
75% {
  transform: scale(1.05);
}
}
.xiaozun{
  width: 300px;
  height: 340px;
  background: url('../../public/guangming_milk/xiaozunpreload.gif') no-repeat;
  background-size: 300px 340px;
  position: absolute;
  left:calc(50% - 150px);
  bottom: 45vh;
}
.xiaozun2{
  width: 300px;
  height: 340px;
  background: url("../../public/guangming_milk/xiaozunpreload.gif") no-repeat;
  background-size: 300px 340px;
  margin: 0 auto;

  position: relative;
  /*bottom: 28vh;*/
}
.dianji{
  width: 323px;
  height: 212px;
  background: url("../../public/guangming_milk/png/dianji.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: -174px;
  left: 114px;
  z-index: 5;
}
.logo{
  width: 750px;
  height: 201px;
  position: absolute;
  background: url("../../public/guangming_milk/png/pre_logo.png") no-repeat;
  background-size: 100% 100%;
  top: 5px;
}
</style>
